import {useSelector} from 'react-redux';

import {selectLanguageCode} from '../../../state/selectors/global';

const useLanguageChange = () => {
    const languageCode = useSelector(selectLanguageCode);

    return languageCode;
};

export default useLanguageChange;
